// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"152":"base","933":"auth","962":"home"}[chunkId] + "." + {"152":"57dec568","933":"9ec6e46e","962":"0043d2c4"}[chunkId] + ".js";
};